module.exports = __webpack_public_path__ + "img/req_cus_bg.710d82e4.png";